import { createStyles, makeUiStyles } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles(() => createStyles({
  root: {
    border: 0,
    margin: 0,
    display: 'inline-flex',
    padding: 0,
    position: 'relative',
    minWidth: 0,
    flexDirection: 'column',
    verticalAlign: 'top'
  }
}), { name: 'FormFieldset', index: StylesIndexInjections.UI_ATOMS });
